import React, { ReactElement } from 'react'

import {
   AuthSessionProvider,
   CookieDetails,
   SessionDetails
} from '@flowwai-frontend/shared/auth/common'

import { CookieAuthSession } from '../CookieAuthSession/CookieAuthSession'

export const CookieAuthSessionProvider = (props: {
   children: ReactElement
   cookieDetails: CookieDetails
   sessionDetails?: SessionDetails
}) => {
   const { children, cookieDetails, sessionDetails } = props

   return (
      <AuthSessionProvider
         getAuthSession={() =>
            new CookieAuthSession(cookieDetails, sessionDetails)
         }
      >
         {children}
      </AuthSessionProvider>
   )
}
